import styles from './InfoModalWindow.module.scss';
import Box from '@components/Box/Box.tsx';
import FormErrorMessage from '@components/FormErrorMessage';
import { Button, ButtonType, ButtonSize } from '@components/Button';
import { Column, Grid, Row } from '@components/Grid';
import { IInfoModalWindowProps } from '../../types';
import { removeMatching } from '@api/apiClient/dropshipping.ts';
import { Text, TextSize, TextType } from '@components/Text';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

const InfoModalWindow = (props: IInfoModalWindowProps) => {
  const {
    handlerRefreshData,
    handlerSetIsOpenInfoWindow,
    matchingId,
    isPaidMatching,
  } = props;

  const { t } = useTranslation();

  const {
    error: errorRemoveMatching,
    isError: isErrorRemoveMatching,
    isLoading: isLoadingRemoveMatching,
    mutate: mutateRemoveMatching
  } = useMutation({
    mutationFn: removeMatching,
    onSuccess: () => {
      handlerRefreshData();
      handlerSetIsOpenInfoWindow(false);
    }
  });

  return (
      <Grid>
        <Row>
          <Column phone={12}>
            <Box mb={4}>
              <Text type={TextType.H1}>
                {t(`dropshipping.removeModal.${isPaidMatching ? 'title' : 'titleOld'}`)}
              </Text>
            </Box>
            <Box pb={2}>
              <Text size={TextSize.M}>
                {t(`dropshipping.removeModal.${isPaidMatching ? 'description' : 'descriptionOld'}`)}
              </Text>
            </Box>
          </Column>
        </Row>
        <div className={styles.actions}>
          <Button
            onClick={() => handlerSetIsOpenInfoWindow(false)}
            title={t('dropshipping.removeModal.cancel')}
            type={ButtonType.SKELETON}
            size={ButtonSize.S}
          />
          <Button
            onClick={() => mutateRemoveMatching(matchingId)}
            pending={isLoadingRemoveMatching}
            title={t('dropshipping.removeModal.approve')}
            size={ButtonSize.S}
          />
        </div>
        {isErrorRemoveMatching && <FormErrorMessage error={errorRemoveMatching}/>}
      </Grid>
  );
};

export default InfoModalWindow;
